export default "__VITE_ASSET__CMgIuBQL__"